import { Component, output } from '@angular/core';
import { SliderModule } from 'primeng/slider';
import { ThemeService } from '../../services/theme.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-font-size-select',
  imports: [SliderModule, FormsModule],
  templateUrl: './font-size-select.component.html',
  styles: ``
})
export class FontSizeSelectComponent {
  fontSize: number;
  changed = output();

  constructor(private theme: ThemeService) {
    this.fontSize = this.theme.fontSize;
  }

  changeBaseFontSize({value}: {value?: number}) {
    this.theme.fontSize = value!;
    this.changed.emit();
  }
}
